<template>
  <div class="container">
    <div class="">
      <i class="iconfont icon-chenggong"></i>
    </div>
    <div class="result">注册成功</div>
    <div class="prompt">您的注册信息已经保存，现在可以使用xxx账号进行登录，您可以选择以下操作：</div>
    <div>
      <el-button type="danger" @click="goMember">完善资料</el-button>
      <el-button @click="goIndex">返回首页</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "registerSuccess",
    data() {
      return {}
    },
    methods: {
      //回到首页
      goIndex(){
        this.$router.push("/");
      },
      //回到首页
      goMember(){
        this.$router.push("/memberCenterIndex/personalInformation");
      }
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    align-items: center;
    padding-top: 200px;
    flex-direction: column;
  }

  icon-chenggong {
    font-size: 50px;
    color: #19BE6B;
  }

  .result {
    font-size: 22px;
    margin: 15px 0px;
  }

  .prompt {
    font-size: 14px;
    color: #878686;
    margin: 15px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/registerSuccess.vue